export default __webpack_public_path__ + "static/media/lisieux15.7e29d04c.jpg";